import { Breadcrumb, message, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAnnouncement } from "../../../../hooks/useAnnouncement";
import { AddEditAnnouncementForm } from "../components/AddEditAnnouncementForm";

const { Title } = Typography;

export function AnnouncementDetail() {
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const { data, create, update } = useAnnouncement(id);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        image: data.imageUrl
          ? [
              {
                uid: "-1",
                name: "image",
                status: "done",
                url: data.imageUrl,
              },
            ]
          : [],
        startDate: data.startDate ? dayjs(data.startDate) : undefined,
        endDate: data.endDate ? dayjs(data.endDate) : undefined,
      });
    }
  }, [data, form]);

  const handleSubmit = async (values) => {
    try {
      if (id && id !== "create") {
        await update.mutateAsync({ id, body: values });
        form.resetFields();
        message.success("Cập nhật dữ liệu thành công");
        return;
      }

      const res = await create.mutateAsync(values);
      navigate(`/bang-dieu-khien/thong-bao/${res._id}`);
      message.success("Tạo dữ liệu thành công");
    } catch (error) {
      console.error(error);
      message.error(`${error || "Lỗi hệ thống."}`);
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: 24, padding: 24 }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Breadcrumb
            items={[
              { title: "Bảng điều khiển" },
              { title: "Thông báo", href: "/bang-dieu-khien/thong-bao" },
              {
                title:
                  id && id !== "create"
                    ? "Chi tiết thông báo"
                    : "Tạo thông báo",
              },
            ]}
          />
          <Title level={3} style={{ margin: 0 }}>
            {id && id !== "create" ? "Chi tiết thông báo" : "Tạo thông báo"}
          </Title>
        </div>
      </div>

      <div>
        <AddEditAnnouncementForm
          form={form}
          loading={create.isPending || update.isPending}
          onSubmit={handleSubmit}
          onCancel={() => navigate("/bang-dieu-khien/thong-bao")}
        />
      </div>
    </div>
  );
}
